/**
 * @generated SignedSource<<61e3bae4e181ed313689f71e4e72c5d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkValueFirstInstallment_charge$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
  } | null | undefined;
  readonly customer: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly paymentMethods: ReadonlyArray<{
    readonly value?: number | null | undefined;
    readonly valueWithDiscount?: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PaymentLinkValueFirstInstallment_charge";
};
export type PaymentLinkValueFirstInstallment_charge$key = {
  readonly " $data"?: PaymentLinkValueFirstInstallment_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkValueFirstInstallment_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkValueFirstInstallment_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "paymentMethods",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "valueWithDiscount",
              "storageKey": null
            }
          ],
          "type": "PaymentMethodPix",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "0b7ddeb67862553bb9e7be426be06d02";

export default node;
